import _get from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _toConsumableArray from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _createClass from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createSuper";
import _classCallCheck from "/home/jenkins/jenkins_slave/workspace/build_webui_utest/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";

/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.22/esri/copyright.txt for details.
*/
import { a as t, f as s, k as e, c as n } from "../../../chunks/vec2.js";
import { a as r } from "../../../chunks/vec2f64.js";
import { defaults as i } from "./Settings.js";
import { objectEqual as o } from "./snappingUtils.js";
import { intersectLineAndPoint as c, intersectCircleAndPoint as a, intersectLineAndRay as h, intersectLineLikeAndCircle as u, pointToLineDistance as p, projectPointToRay as d, projectPointToLine as l, projectPointToCircle as f } from "../../support/geometry2dUtils.js";

var j = function j(t) {
  _classCallCheck(this, j);

  this.coordinateHelper = t;
};

var m = /*#__PURE__*/function (_j) {
  _inherits(m, _j);

  var _super = _createSuper(m);

  function m(t, s) {
    var _this;

    _classCallCheck(this, m);

    _this = _super.call(this, t), _this.point = s;
    return _this;
  }

  _createClass(m, [{
    key: "objectEqual",
    value: function objectEqual(t) {
      return t instanceof m && o(this.point, t.point);
    }
  }, {
    key: "check",
    value: function check(s) {
      return t(s, this.point) < i.pointThreshold;
    }
  }, {
    key: "closestTo",
    value: function closestTo() {
      return this.coordinateHelper.clone(this.point);
    }
  }, {
    key: "intersect",
    value: function intersect(t) {
      var _this2 = this;

      var s = [];
      return t instanceof b ? s.push.apply(s, _toConsumableArray(c({
        start: t.start,
        end: t.end,
        type: t instanceof E ? 1 : 0
      }, this.point))) : t instanceof k && s.push.apply(s, _toConsumableArray(a(t.center, t.radius, this.point))), s.map(function (s) {
        return new H(_this2.coordinateHelper, s, _this2, t);
      });
    }
  }]);

  return m;
}(j);

var b = /*#__PURE__*/function (_j2) {
  _inherits(b, _j2);

  var _super2 = _createSuper(b);

  function b(t, s, e) {
    var _this3;

    _classCallCheck(this, b);

    _this3 = _super2.call(this, t), _this3.start = s, _this3.end = e;
    return _this3;
  }

  _createClass(b, [{
    key: "objectEqual",
    value: function objectEqual(t) {
      return t instanceof b && o(this.start, t.start) && o(this.end, t.end);
    }
  }, {
    key: "intersect",
    value: function intersect(t) {
      var _this4 = this;

      var s = [];
      return t instanceof m ? s.push.apply(s, _toConsumableArray(c({
        start: this.start,
        end: this.end,
        type: this instanceof E ? 1 : 0
      }, t.point))) : t instanceof b ? s.push.apply(s, _toConsumableArray(h({
        start: this.start,
        end: this.end,
        type: this instanceof E ? 1 : 0
      }, {
        start: t.start,
        end: t.end,
        type: t instanceof E ? 1 : 0
      }))) : t instanceof k && s.push.apply(s, _toConsumableArray(u({
        start: this.start,
        end: this.end,
        type: this instanceof E ? 1 : 0
      }, t.center, t.radius))), s.map(function (s) {
        return new H(_this4.coordinateHelper, s, _this4, t);
      });
    }
  }]);

  return b;
}(j);

var q = /*#__PURE__*/function (_b) {
  _inherits(q, _b);

  var _super3 = _createSuper(q);

  function q(t, s, e) {
    var _this5;

    _classCallCheck(this, q);

    _this5 = _super3.call(this, t, s, e), _this5.dir = r(), _this5.p = r();
    return _this5;
  }

  _createClass(q, [{
    key: "objectEqual",
    value: function objectEqual(t) {
      return t instanceof q && _get(_getPrototypeOf(q.prototype), "objectEqual", this).call(this, t);
    }
  }, {
    key: "check",
    value: function check(t) {
      return s(this.dir, this.end, this.start), s(this.p, t, this.start), e(this.dir, this.p) >= 0 && p(t, this.start, this.end) < i.pointOnLineThreshold;
    }
  }, {
    key: "closestTo",
    value: function closestTo(t) {
      var s = this.coordinateHelper.clone(t);
      return d(s, t, this.start, this.end), s;
    }
  }]);

  return q;
}(b);

var E = /*#__PURE__*/function (_b2) {
  _inherits(E, _b2);

  var _super4 = _createSuper(E);

  function E(t, s, e) {
    _classCallCheck(this, E);

    return _super4.call(this, t, s, e);
  }

  _createClass(E, [{
    key: "objectEqual",
    value: function objectEqual(t) {
      return t instanceof E && _get(_getPrototypeOf(E.prototype), "objectEqual", this).call(this, t);
    }
  }, {
    key: "check",
    value: function check(t) {
      return p(t, this.start, this.end) < i.pointOnLineThreshold;
    }
  }, {
    key: "closestTo",
    value: function closestTo(t) {
      var s = this.coordinateHelper.clone(t);
      return l(s, t, this.start, this.end), s;
    }
  }]);

  return E;
}(b);

var H = /*#__PURE__*/function (_j3) {
  _inherits(H, _j3);

  var _super5 = _createSuper(H);

  function H(t, s, e, n) {
    var _this6;

    _classCallCheck(this, H);

    _this6 = _super5.call(this, t), _this6.intersection = s, _this6.first = e, _this6.second = n;
    return _this6;
  }

  _createClass(H, [{
    key: "objectEqual",
    value: function objectEqual(t) {
      return t instanceof H && this.first.objectEqual(t.first) && this.second.objectEqual(t.second);
    }
  }, {
    key: "check",
    value: function check() {
      return !1;
    }
  }, {
    key: "closestTo",
    value: function closestTo(t) {
      var s = this.coordinateHelper.clone(t);
      return n(s, this.intersection), s;
    }
  }, {
    key: "intersect",
    value: function intersect() {
      return [];
    }
  }]);

  return H;
}(j);

var k = /*#__PURE__*/function (_j4) {
  _inherits(k, _j4);

  var _super6 = _createSuper(k);

  function k(t, s, e) {
    var _this7;

    _classCallCheck(this, k);

    _this7 = _super6.call(this, t), _this7.center = s, _this7.radius = e;
    return _this7;
  }

  _createClass(k, [{
    key: "objectEqual",
    value: function objectEqual(t) {
      return t instanceof k && this.center[0] === t.center[0] && this.center[1] === t.center[1] && this.radius === t.radius;
    }
  }, {
    key: "check",
    value: function check() {
      return !1;
    }
  }, {
    key: "closestTo",
    value: function closestTo(t) {
      var s = this.coordinateHelper.clone(t);
      return f(s, t, this.center, this.radius), s;
    }
  }, {
    key: "intersect",
    value: function intersect(t) {
      var _this8 = this;

      var s = [];
      return t instanceof b ? s.push.apply(s, _toConsumableArray(u({
        start: t.start,
        end: t.end,
        type: t instanceof E ? 1 : 0
      }, this.center, this.radius))) : t instanceof m && s.push.apply(s, _toConsumableArray(a(this.center, this.radius, t.point))), s.map(function (s) {
        return new H(_this8.coordinateHelper, s, _this8, t);
      });
    }
  }]);

  return k;
}(j);

export { H as IntersectionConstraint, E as LineConstraint, b as LineLikeConstraint, k as PlanarCircleConstraint, m as PointConstraint, q as RayConstraint, j as SnappingConstraint };